import { createSelector } from '@reduxjs/toolkit';
import { IGlobalReduxStore } from 'store';

const getUserPermissions = (state: IGlobalReduxStore) => state.auth.permissions;

export const isCustomFieldsFeatureEnabledSelector = createSelector(
  getUserPermissions,
  (permissions) => {
    if (permissions?.CUSTOM_FIELDS?.access)
      return permissions.CUSTOM_FIELDS.access.includes('read');
    else return false;
  },
);
